import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsSortDescendingIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M767.2 645.4L557.2 846c-11.6 12-27.4 18-44.8 18s-33-6-44.8-18L256.8 645.4c-25-23.8-25-62.6 0-86.4s65.4-23.8 90.4 0L448 655.4v-434c0-33.8 28.6-61.2 64-61.2s64 27.4 64 61.2v434L676.8 559c25-23.8 65.4-23.8 90.4 0s25 62.4 0 86.4z" />
    </g>
  </StyledIcon>
)

CsSortDescendingIcon.displayName = 'CsSortDescendingIcon'
